import LoadingPoints from "../../../utils/Loading/Points";
import CheckBox from "../../Checkbox";
import Pesquisar from "../../Pesquisar";
import { Grup, Table, Tbody, Td, Th, Theader, Theader2, Trbody } from "./style";

/**
 * Componente de tabela reutilizável para exibir alunos
 * @param {Object} props - Propriedades do componente
 * @param {Array} props.alunos - Lista de alunos a serem exibidos
 * @param {Array} props.selecionarAluno - Lista de alunos selecionados
 * @param {Function} props.handleSelecionar - Função para selecionar/deselecionar alunos
 * @param {Object} props.alunoLoading - Estado de loading por aluno
 * @param {boolean} props.showSearch - Se deve mostrar os campos de pesquisa
 * @param {Function} props.setSearchRm - Função para atualizar o estado de busca por RM
 * @param {Function} props.setSearchNome - Função para atualizar o estado de busca por nome
 * @param {boolean} props.isSelectedTable - Se é a tabela de alunos selecionados
 * @param {string} props.emptyMessage - Mensagem a ser exibida quando não há alunos
 */
const AlunosTable = ({
  alunos,
  selecionarAluno,
  handleSelecionar,
  alunoLoading,
  showSearch = false,
  setSearchRm,
  setSearchNome,
  isSelectedTable = false,
  emptyMessage = "Nenhum aluno encontrado",
  showEmptyMessage = false,
  isRevisaoMode = false,
}) => {
  // Determina qual componente de cabeçalho usar com base em se é a tabela de alunos selecionados
  const HeaderComponent = isSelectedTable ? Theader : Theader2;

  return (
    <Table>
      <HeaderComponent>
        <tr>
          {showSearch ? (
            <>
              <Th>
                <Grup>
                  <Pesquisar
                    width={"5rem"}
                    color="white"
                    placeholder="RM"
                    apenasNumeros={true}
                    name="rm"
                    placeholdercolor="white"
                    event={(e) => setSearchRm(e.target.value)}
                  />
                </Grup>
              </Th>
              <Th>
                <Grup>
                  <Pesquisar
                    width={"100%"}
                    color="white"
                    placeholder="Nome"
                    name="nome"
                    placeholdercolor="white"
                    event={(e) => setSearchNome(e.target.value)}
                  />
                </Grup>
              </Th>
            </>
          ) : (
            <>
              <Th style={{ width: "5rem" }}>RM</Th>
              <Th>Nome</Th>
            </>
          )}
          {/* <Th>Curso</Th> */}
          <Th style={{ width: "10%", minWidth: "5rem" }}>Convênio</Th>
          {!isRevisaoMode ? (
            <Th style={{ width: "8%", minWidth: "5rem" }}>
              <p>Selecionar</p> Aluno
            </Th>
          ) : null}
        </tr>
      </HeaderComponent>
      {alunos && alunos.length > 0 ? (
        <Tbody>
          {alunos
            .sort((a, b) => {
              // Primeiro ordena por dt_inicio
              const dateA = new Date(a.dt_inicio);
              const dateB = new Date(b.dt_inicio);

              if (dateA.getTime() !== dateB.getTime()) {
                return dateB - dateA;
              }

              // Se as datas forem iguais, ordena por nome_aluno
              return a.nome_aluno.localeCompare(b.nome_aluno);
            })
            .map((aluno, index) => (
              <Trbody key={index}>
                <Td className="convenioTd">{aluno?.rm}</Td>
                <Td>{aluno?.nome_aluno}</Td>
                {/* <Td>{aluno?.nome_curso}</Td> */}
                <Td className="convenioTd">{aluno?.convenio}</Td>
                {!isRevisaoMode ? (
                  <Td className="checkbox">
                    {alunoLoading[aluno.id] ? (
                      <LoadingPoints />
                    ) : (
                      <CheckBox
                        flexdirection={"column"}
                        checked={selecionarAluno.some(
                          (selectedAluno) => selectedAluno.id === aluno.id && selectedAluno.rm === aluno.rm
                        )}
                        event={() => handleSelecionar(aluno)}
                      />
                    )}
                  </Td>
                ) : null}
              </Trbody>
            ))}
        </Tbody>
      ) : (
        showEmptyMessage && (
          <Tbody>
            <Trbody>
              <Td colSpan={4}>{emptyMessage}</Td>
            </Trbody>
          </Tbody>
        )
      )}
    </Table>
  );
};

export default AlunosTable;
